const S3KEY_PREFIX = "s3key://";

export function containsPresignedUrls(html: string): boolean {
  return /src="https:\/\/[^"]*\.amazonaws\.com[^"]*X-Amz-Signature[^"]*"/.test(html);
}

export function extractS3Keys(html: string): string[] {
  const matches = html.matchAll(/src="s3key:\/\/([^"]+)"/g);
  return [...matches].map((m) => m[1]);
}

export function applyResolvedUrls(
  html: string,
  resolved: Record<string, string>,
): string {
  return html.replace(/src="s3key:\/\/([^"]+)"/g, (_match, key) => {
    const url = resolved[key];
    return url ? `src="${url}"` : `src="s3key://${key}"`;
  });
}

export function replaceSignedUrlsWithS3Keys(
  html: string,
  resolvedMap: Record<string, string>,
): string {
  if (!html || Object.keys(resolvedMap).length === 0) return html;
  let result = html;
  for (const [key, signedUrl] of Object.entries(resolvedMap)) {
    const urlBase = signedUrl.split("?")[0];
    const escapedBase = urlBase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    result = result.replace(
      new RegExp(`src="${escapedBase}(?:[^"&]|&(?:amp;)?)*"`, "g"),
      `src="s3key://${key}"`,
    );
  }
  return result;
}
